import { useEffect } from 'react';
import { getNotificationApi } from '../utils/safeNotification';

function urlBase64ToUint8Array(base64String) {
  if (!base64String) return new Uint8Array(0);
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const out = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) out[i] = rawData.charCodeAt(i);
  return out;
}

/**
 * Web Push (VAPID) для PWA админки: уведомления в фоне о вызовах и новых заказах.
 * Только production (регистрация sw.js в index.js) + на сервере VAPID_*, миграция 028.
 */
export function useStaffWebPush({ enabled, api, restaurantId, userRole }) {
  useEffect(() => {
    if (!enabled || !restaurantId || !api) return;
    if (process.env.NODE_ENV !== 'production') return;
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
    if (!('PushManager' in window)) return;
    const Notif = getNotificationApi();
    if (!Notif) return;

    let cancelled = false;
    (async () => {
      try {
        const { data, status } = await api.get('/api/staff/push/vapid-public');
        if (cancelled || status === 503 || !data?.publicKey) return;

        let perm = Notif.permission;
        if (perm === 'default') {
          perm = await Notif.requestPermission();
        }
        if (perm !== 'granted') return;

        const reg = await navigator.serviceWorker.ready;
        const key = urlBase64ToUint8Array(data.publicKey);
        if (key.length === 0) return;

        let sub = await reg.pushManager.getSubscription();
        if (!sub) {
          sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
        }
        if (cancelled) return;
        await api.post('/api/staff/push/subscribe', {
          subscription: sub.toJSON(),
          restaurantId: userRole === 'superadmin' ? restaurantId : undefined,
        });
      } catch (e) {
        if (e?.response?.status !== 503) {
          console.warn('useStaffWebPush:', e?.message || e);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [enabled, restaurantId, api, userRole]);
}
